import {getCoralServiceDataFromParent} from "../handlers/ParentDataHandler";
import {getStationCode} from "../utils/Helper";

export const getOpsClockData = (dispatchDate) => {
  const request = getLMOpsCoralServiceRequest(
    "getOpsClock",
    {
      dispatchDate,
      nodeId : getStationCode()
    }
  );
  return getCoralServiceDataFromParent(request);
};

export const getLMOpsCoralServiceRequest = (endPoint, requestBody) => {
  return {
    processName: "lmOpsClockService",
    endPoint,
    request : JSON.stringify(requestBody)
  };
}


// WEBPACK FOOTER //
// ./src/apis/LMOpsApi.js